// The citation panel body for the app right sidebar (SIDEBAR_LENS_REWORK —
// supersedes the in-page slide-over that used to live in ThreadChatView):
// opening a citation now PUSHES the transcript via centerMarginRight instead
// of covering it. Same four states as the slide-over had: loading, a full
// article (ArticleDetailPanel, which brings its own close control), a
// peer-only doc notice, and "source unavailable". The non-article states get
// their own X — the slide-over's click-the-scrim dismissal has no equivalent
// in the sidebar.
import { X } from "lucide-react";

import ArticleDetailPanel from "../../Universal/ArticleCardDetailPanel";
import LoadingSpinner from "../../Universal/LoadingSpinner";

const CloseRow = ({ onClose }) => (
  <div className="flex justify-end border-b border-mainDivider px-2 py-1.5">
    <button
      type="button"
      onClick={onClose}
      title="Close source"
      className="rounded-md p-1 text-mutedText transition hover:text-mainText"
    >
      <X size={14} />
    </button>
  </div>
);

const ThreadCitationPanel = ({ state, onClose, t }) => (
  <div className="flex h-full min-h-0 flex-col bg-mainBg font-poppins">
    {state?.loading ? (
      <>
        <CloseRow onClose={onClose} />
        <div className="flex flex-1 flex-col items-center justify-center gap-2">
          <LoadingSpinner />
          <span className="text-xs text-mutedText">Loading source…</span>
        </div>
      </>
    ) : state?.article ? (
      <div className="flex min-h-0 flex-1 flex-col">
        {state.peer && (
          <div className="flex justify-center border-b border-mainDivider py-1">
            <span className="rounded-full border border-amber-400/40 px-2 py-0.5 text-[9px] uppercase tracking-[0.14em] text-amber-400">
              federated source
            </span>
          </div>
        )}
        <ArticleDetailPanel
          article={state.article}
          cardId={state.article.document_id}
          onClose={onClose}
          t={t}
        />
      </div>
    ) : state?.peerDoc ? (
      <>
        <CloseRow onClose={onClose} />
        <div className="flex flex-1 flex-col items-center justify-center gap-2 px-6 text-center">
          <span className="rounded-full border border-amber-400/40 px-2 py-0.5 text-[9px] uppercase tracking-[0.14em] text-amber-400">
            federated source
          </span>
          <div className="text-xs text-mainText">{state.peerDoc.title}</div>
          <div className="text-[11px] text-mutedText">
            This document lives on the peer server and isn&apos;t locally
            retrievable. Its snippet grounded the answer above.
          </div>
        </div>
      </>
    ) : (
      <>
        <CloseRow onClose={onClose} />
        <div className="flex flex-1 items-center justify-center text-xs text-mutedText">
          Source unavailable.
        </div>
      </>
    )}
  </div>
);

export default ThreadCitationPanel;
